/**
 * RobinGO site rule: navigational links open in a new browser tab.
 * Same-page anchors and non-page actions remain in the current tab.
 */
(function () {
  const skipProtocols = /^(?:mailto:|tel:|sms:|javascript:|data:)/i;

  function isNavigationalLink(link) {
    const href = (link.getAttribute('href') || '').trim();

    if (
      !href ||
      href.startsWith('#') ||
      skipProtocols.test(href) ||
      link.hasAttribute('download') ||
      link.hasAttribute('data-robingo-same-tab') ||
      link.matches('.pagination__link') ||
      link.closest('.pagination') ||
      link.getAttribute('role') === 'button' ||
      link.hasAttribute('aria-controls')
    ) {
      return false;
    }

    try {
      const destination = new URL(link.href, window.location.href);
      const current = new URL(window.location.href);

      if (!/^https?:$/.test(destination.protocol)) return false;

      const isSameDocumentAnchor =
        destination.origin === current.origin &&
        destination.pathname === current.pathname &&
        destination.search === current.search &&
        destination.hash;

      return !isSameDocumentAnchor;
    } catch (_error) {
      return false;
    }
  }

  function applyNewTabRule(root) {
    const links = [];

    if (root instanceof HTMLAnchorElement) links.push(root);
    if (root.querySelectorAll) links.push(...root.querySelectorAll('a[href]'));

    links.forEach((link) => {
      if (!isNavigationalLink(link)) return;

      link.target = '_blank';
      const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      link.setAttribute('rel', Array.from(rel).join(' '));
    });
  }

  function start() {
    applyNewTabRule(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) applyNewTabRule(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
